"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var $ = require("jquery");
var l = require("lenovo");
var lenovo_1 = require("lenovo");
var Lmd = lenovo_1.DTM.Lmd;
var currentRealm = l.Common.getCurrentRealm();
var translate = [
    "capssn search title|Enter a serial number to detect your product",
    "capssn search|Enter Serial Number",
    "submit|Submit",
    "detect serial number|Detect Serial Number",
    "detect summary|This secure scan allows us to easily identify your device"
];
translate = l.Translator.translateGroup(translate);
var render = function (element, searchType, callback) {
    if (searchType === lenovo_1.SearchComponentType.CapsSn) {
        var isMobileOrTablet = l.MobileDetectControl.mobileResource.mobile() || l.MobileDetectControl.mobileResource.tablet();
        if (currentRealm === lenovo_1.RealmType.Moto) {
            //old caps on moto site
            ReactDOM.render(React.createElement("div", { className: "caps-sn-search" },
                React.createElement("div", { className: "sn-search-label", style: { display: "none" } },
                    React.createElement("span", null, translate["capssn search title"])),
                React.createElement("input", { className: "typeahead form-control", type: "text", required: true, placeholder: translate["capssn search"] }),
                React.createElement("button", { className: "caps-sn-submit" }, translate["submit"])), element);
        }
        else {
            //new caps on non-moto sites
            if (l.Common.isWin7OrAbove() && !isMobileOrTablet && currentRealm === lenovo_1.RealmType.Pcg) {
                //only show lsb on pc website and in PC webview version
                var lsbV5Detect_1 = function () {
                    LSBV5.Dispatcher.addOnlyEventListener(LSBV5.EventTypeEnum.CloseInstallCallBack, LSBV5.ComponentTypeEnum.Detect, function (data) {
                        $('.caps-loading').hide();
                        console.log("LSBV5.EventTypeEnum.CloseInstallCallBack:", data);
                    });
                    LSBV5.Detect.run(function (data) {
                        console.log('LSB Detect success');
                        console.log(data);
                        window["LSB_Flag"] = true;
                        l.DTM.push({
                            type: "eSupportProcess_Complete",
                            name: "LSB:SuccessfulMachineDetection",
                            action: "Button Click",
                            eSupportDeviceInfo: {
                                serialNumber: data.SN,
                                machineTypeModel: data.MTM
                            }
                        });
                        var $currentCaps = $(element).parents("div[id^=" + l.GlobalVar.litePageIdPrefix + "]:first");
                        var $searchBox = $currentCaps.find("#caps-search input.typeahead.tt-input");
                        $searchBox.typeahead('val', '');
                        $searchBox.focus().typeahead('val', data.SN).focus();
                        $currentCaps.find("#caps-search .icon-search").trigger("click");
                        $('.caps-loading').hide();
                    }, function (errorData) {
                        $('.caps-loading').hide();
                        console.log('Detect error: ', errorData);
                    });
                };
                var detectButton = (React.createElement("div", { className: "small caps-lsb-detect", onClick: function () { $('.caps-loading').show(); lsbV5Detect_1(); } },
                    React.createElement("span", { className: "icon-lsb" }),
                    React.createElement("span", null, translate["detect serial number"])));
                ReactDOM.render(React.createElement("div", { className: "caps-sn-search" },
                    React.createElement("div", { className: "sn-search-label" },
                        detectButton,
                        React.createElement("p", null, translate["detect summary"]))), element);
            }
            else {
                ReactDOM.render(React.createElement("div", { className: "caps-sn-search" }), element);
                $(element).hide();
            }
        }
    }
    if (callback)
        callback();
};
exports.load = function (element, searchType, linkTrackType, callback) {
    if (linkTrackType === void 0) { linkTrackType = Lmd.dicLinkTrackType["Unknown"]; }
    render(element, searchType, callback);
};
